import { Average } from "@/components/Average/Average";
import { Flex } from "@aircall/tractor";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

function BasicCase() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <Average value={95} />
      <Average value={75} />
      <Average value={60} />
      <Average value={35} />
      <Average value={15} />
    </Flex>
  );
}

function EdgeCases() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <Average value={null} />
      <Average value={-10} />
      <Average value={120} />
      <Average value={0} />
      <Average value={100} />
    </Flex>
  );
}

function VariantCases() {
  return (
    <Flex gap="m" flexDirection="column">
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={85} variant="supportingRegularXS" />
        <Average value={85} variant="supportingRegularS" />
        <Average value={85} variant="bodyRegularS" />
        <Average value={85} variant="bodyRegularM" />
        <Average value={85} variant="bodyMediumS" />
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={85} variant="supportingSemiboldXS" />
        <Average value={85} variant="supportingSemiboldS" />
        <Average value={85} variant="bodySemiboldS" />
        <Average value={85} variant="bodySemiboldM" />
        <Average value={85} variant="headingBoldXS" />
      </Flex>
    </Flex>
  );
}

function BorderlessCase() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <Average value={95} borderless />
      <Average value={75} borderless />
      <Average value={60} borderless />
      <Average value={35} borderless />
      <Average value={15} borderless />
      <Average value={null} borderless />
    </Flex>
  );
}

function RatingScaleExamples() {
  return (
    <Flex gap="m" flexDirection="column">
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={100} />
        <span>Excellent (85-100%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={77} />
        <span>Good (70-85%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={60} />
        <span>Fair (50-70%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={35} />
        <span>Poor (20-50%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={10} />
        <span>Very Poor (0-20%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <Average value={null} />
        <span>Not Applicable (null)</span>
      </Flex>
    </Flex>
  );
}

export function PlaygroundAverage() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Rating Scale Examples
        </PlaygroundSubSectionTitle>
        <RatingScaleExamples />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Typography Variants
        </PlaygroundSubSectionTitle>
        <VariantCases />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Borderless</PlaygroundSubSectionTitle>
        <BorderlessCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Edge Cases</PlaygroundSubSectionTitle>
        <EdgeCases />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
